import States from 'login-constants/states';
import { getWindow } from 'login-utils/globalWrappers';

export const linkToSignup: FooterConfig = {
  description: "Don't have an account?",
  link: {
    text: 'Sign Up',
    state: States.SIGNUP,
    id: 'it-SignUpLink',
  },
  shouldRender() {
    const dconf = getWindow().DEPLOYMENT_CONFIG;
    return !!(dconf && dconf.allowSignup);
  },
};

export const linkToLogin: FooterConfig = {
  description: 'Already have an account?',
  link: {
    text: 'Sign In',
    // Handle a react-router bug where empty strings are considered falsy.
    state: States.LOGIN,
    id: 'it-SignInLink',
  },
  shouldRender: () => true,
};

export const linkToFastForward: FooterConfig = {
  description: null,
  link: {
    text: 'Dev Tools',
    state: States.FAST_FORWARD,
    id: 'it-FFLink',
  },
  shouldRender: () => true,
};
